import React, { useContext } from 'react';
import classNames from 'classnames';
import withSpinner from '../../shared/hoc/withSpinner';
import { AuthContext, Page, Title } from '../../shared';
import { ReactComponent as BeeHeroIcon } from '../../images/BeeHeroIcon.svg';
import styles from '../Main.module.scss';
import MainHoc from '../MainHoc';
import { SERVICE_STATE } from '../../shared/consts';
import { SERVICE_ERROR_MESSAGE, SERVICE_MAINTENANCE_MESSAGE, SERVICE_MORE_INFO } from './textConsts';
import useMediaQuery from '../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../shared/MediaQuery/mediaQueryUtils';

const Maintenance = () => {
    const isMobile = useMediaQuery(isMobileQuery);
    const { serviceState } = useContext(AuthContext);

    const getMessage = () => {
        switch (serviceState) {
            case SERVICE_STATE.ERROR:
                return SERVICE_ERROR_MESSAGE;
            default:
                return SERVICE_MAINTENANCE_MESSAGE;
        }
    };

    return (
        <MainHoc>
            <div className={classNames({ [styles.content]: !isMobile })}>
                <Page>
                    <Page.Section>
                        <Title small subtitleMargin flex title="BeeHero" svg={BeeHeroIcon} subtitle={''} iconSize={40} />
                    </Page.Section>
                    <div className={classNames(styles.main_message)}>
                        {getMessage()}
                        <span className={classNames(styles.main_message_contact_us)}>
                            {SERVICE_MORE_INFO}&nbsp;
                            <a href="mailto:support@beehero.io" target="_blank" rel="noreferrer">
                                support@beehero.io
                            </a>
                        </span>
                    </div>
                </Page>
            </div>
        </MainHoc>
    );
};

export default withSpinner(Maintenance);
